import React, { FC } from 'react';
import { Search } from './styles';

const SearchIcon: FC = ({ ...rest }) => {
	return <Search {...rest} />;
};

export default SearchIcon;
